import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import { registerServiceWorker } from "./sw-register";
import { initSentry } from "./core/services/sentry";
import { initWebVitals } from "./core/services/telemetry";
import "./core/i18n";

// ─── PHASE 1: Initialize observability (errors, web vitals) ──────────────────
initSentry();
initWebVitals();

// Register service worker for offline resilience
registerServiceWorker();

createRoot(document.getElementById("root")).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
);
